export interface UnavailableCode {
  outStateId: string;
  outStateName: string;
  isACW: boolean;
}

export function mapUnavailableCodesResponse(data: unknown): UnavailableCode[] {
  let codes: unknown[] = [];

  if (Array.isArray(data)) {
    codes = data;
  } else if (data && typeof data === 'object') {
    codes =
      ((data as Record<string, unknown>).unavailableCodes as unknown[]) ||
      ((data as Record<string, unknown>).UnavailableCodes as unknown[]) ||
      ((data as Record<string, unknown>).outStates as unknown[]) ||
      ((data as Record<string, unknown>).OutStates as unknown[]) ||
      [];
  }

  return codes.map((item: unknown) => {
    const code = item as {
      outStateId?: string | number;
      OutStateId?: string | number;
      outStateName?: string;
      OutStateName?: string;
      reason?: string;
      isACW?: boolean;
      isAcw?: boolean;
    };
    return {
      outStateId: String(code.outStateId || code.OutStateId || ''),
      outStateName: code.outStateName || code.OutStateName || code.reason || 'Unknown',
      isACW: code.isACW || code.isAcw || false,
    };
  });
}
